import useStoreTableColumns from './useStoreTableColumns'

export default useStoreTableColumns
